import { render, staticRenderFns } from "./ExEmployeeIssueBadge.vue?vue&type=template&id=cf3123fe&scoped=true"
import script from "./ExEmployeeIssueBadge.vue?vue&type=script&lang=js"
export * from "./ExEmployeeIssueBadge.vue?vue&type=script&lang=js"
import style0 from "./ExEmployeeIssueBadge.vue?vue&type=style&index=0&id=cf3123fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3123fe",
  null
  
)

export default component.exports